import type { IWidgetControllerConfig } from '@wix/native-components-infra/dist/src/types/types';
import type { IControllerFactory, IControllerFactories } from '../types';
import { sentryConfPerController } from '../../utils/sentry';

export function getControllerFactory(
  controllerInstances: Record<string, any> | undefined,
  controllerFactories: IControllerFactories | undefined,
  type: IWidgetControllerConfig['type'],
): IControllerFactory | undefined {
  let ctrlFactory: IControllerFactory | undefined;
  const factoriesByType = controllerFactories as
    | Partial<Record<string, IControllerFactory>>
    | undefined;

  if (controllerInstances?.[type]) {
    const controllerFunction = Object.keys(controllerInstances[type]).filter(
      (k) => k.toLowerCase().includes('controller'),
    )[0];
    const sentryConf = sentryConfPerController[type];
    ctrlFactory = {
      factory: controllerInstances[type][controllerFunction],
      ...(sentryConf
        ? {
            sentryDSN: sentryConf.dsn,
            baseUrlKey: sentryConf.baseUrlsKey,
          }
        : /* istanbul ignore next */ {}),
    };
  } else if (factoriesByType?.[type]) {
    ctrlFactory = factoriesByType[type] as IControllerFactory;
  }
  return ctrlFactory;
}
